import { IssueStatusName } from '@helios/ag-grid-config'
import { Daterange } from '@northfork/ng-basics'

export interface Distribution {
  tranId?: string
  legacyOrigId?: number
  acctId: number
  tranTypeCode: TranTypeCode
  currencyCode?: string

  isCalculated: boolean

  // newly added fields
  matchedStatus: MatchedStatus
  calculatedAmount?: number
  calculatedAmountTotal?: number
  settleDate: string
  postDate: string
  calculatedSettleDate?: string
  settleDateDifference?: number
  postDateDifference?: number

  entryDate: string
  calculatedEntryDate?: string
  calculatedPostDate?: string
  actualEntryDate?: string
  actualSettleDate?: string
  actualPostDate?: string
  entryDateDifference?: number
  clearedDate?: string

  actualAmount?: number
  actualAmountTotal?: number
  amountTotalDifference?: number
  rate?: number
  loss?: number
  originalUnits?: number
  factorizedUnits?: number
  factor?: number
  actualPrepaidInterest?: number
  calculatedPrepaidInterest?: number

  secId: number
  assetId: string
  breakStatus?: IssueStatusName
  inventoryType: string
  collateralBroker?: string
  paymentCurrencyCode?: string
  isLlaRate?: boolean
}

export interface DistributionV2 {
  tranId?: string
  legacyOrigId?: number
  acctId: number
  tranTypeCode: TranTypeCode
  currencyCode?: string

  matchedStatus: MatchedStatus //This indicates if the calculated distribution "matches" up with an actual transaction or not

  entryDate: DistributionDate
  settleDate: DistributionDate
  postDate: DistributionDate
  calculatedEntryDate?: string
  calculatedSettleDate?: string
  calculatedPostDate?: string
  actualEntryDate?: string
  actualSettleDate?: string
  actualPostDate?: string
  clearedDate?: string

  actualAmount?: number
  actualAmountTotal: number
  calculatedAmount?: number
  calculatedAmountTotal: number
  amountDiff?: number
  amountTotalDifference: number
  rate?: number
  loss?: number
  originalUnits: number
  factorizedUnits?: number
  factor?: number
  actualPrepaidInterest?: number
  calculatedPrepaidInterest?: number

  secId: number
  assetId: string
  breakStatus?: IssueStatusName
  groupId: string
  inventoryType: string
  collateralBroker?: string
  paymentCurrencyCode?: string
  isLlaRate?: boolean
}

export interface DistributionDate {
  date: string
  dateDiff?: number
}

export type MatchedStatus = 'MATCHED' | 'ACTUAL_ONLY' | 'CALCULATED_ONLY'

export interface DistributionAdvancedOptions {
  dateRange?: Daterange
}

export interface QuickEnterPredictionAction {
  distributionClicked: Distribution[]
  sessionId?: string
  userId?: number
  sessionReconDate?: Date
}

export enum TranTypeCode {
  CPN = 'CPN',
  DVD = 'DVD',
  MMF = 'MMF',
  PPD = 'PPD',
  FTW = 'FTW',
  RCAP = 'RCAP',
  CAPI = 'CAPI',
  PPU = 'PPU',
  EXP = 'EXP',
}

export const tranTypeCodes = Object.keys(TranTypeCode)
